import React from 'react'

const Backend = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">Technical Skills</h3>

        <div className="skills__box">
            <div className="skills__group">
               
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">PHP/Laravel</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>
                
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Node JS</h3>
                    {/* <span className="skills__level">Intermediate</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">HTML, CSS</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">TypeScript</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Cloud</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">REST APIs</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>
                
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Docker</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">RAG</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

                

            </div>

            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Angular, Vue</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>
                
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Javascript</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">MYSQL</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">NoSQL</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Git</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">OAuth</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">LangChain</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Prompt Engineering</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

            </div>

            
        </div>
    </div>
  )
}

export default Backend